<div class="calendar-header">
  <button
    type="button"
    class="calendar-header__control"
    (click)="previousClicked()"
  >
    <svg-icon
      src="assets/icons/arrow.svg"
      [style]="{
        width: '20px',
        height: '20px',
        fill: 'currentColor',
        transform: 'rotate(-90deg)'
      }"
    ></svg-icon>
  </button>
  <button
    type="button"
    class="calendar-header__label"
    (click)="periodClicked()"
  >
    {{ periodLabel() }}
  </button>
  <button
    type="button"
    class="calendar-header__control"
    (click)="nextClicked()"
  >
    <svg-icon
      src="assets/icons/arrow.svg"
      [style]="{
        width: '20px',
        height: '20px',
        fill: 'currentColor',
        transform: 'rotate(90deg)'
      }"
    ></svg-icon>
  </button>
</div>
